/**
 * Created by filatov on 18.09.2015.
 */
import CostCSVPreviewTwoLevelsColumnsStrategy from './CostCSVPreviewTwoLevelsColumnsStrategy'

export default function CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy() {}

CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype = new CostCSVPreviewTwoLevelsColumnsStrategy();

CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype.init = function({showSpentTime, showAverageRates, showUserRates, showOthers}) {
    CostCSVPreviewTwoLevelsColumnsStrategy.prototype.init.call(
        this,
        {
            showSpentTime: showSpentTime,
            showAverageRates: showAverageRates,
            showOthers: showOthers,
        }
    )
    this.showUserRates = showUserRates
    return this
}

CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype.getLevelNameKey = function(){
    return "report.user";
};

CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showUserRates;
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.js